import React from 'react';
import { observer, PropTypes as MobxPropTypes } from 'mobx-react';

// share dependencies
import PropertiesEditorContainer from 'share/components/controls/Izenda.PropertiesEditorContainer';

// local dependencies
import KPITilePropsSchema from './Izenda.KPITilePropertiesSchema';

/**
 * @function KPITilePropertiesContainer
 * @description render a properties container for KPI Tile Properties
 * @param {object} props function properties
 */
const KPITilePropertiesContainer = props => {
    const configurationDefinition = KPITilePropsSchema(props.reportDetails);
    return (
        <PropertiesEditorContainer propertyConfig={configurationDefinition} />
    );
};

KPITilePropertiesContainer.propTypes = {
    reportDetails: MobxPropTypes.observableObject
};

export default observer(KPITilePropertiesContainer);



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.KPITilePropertiesContainer.jsx